module.exports = __webpack_public_path__ + "img/python-svgrepo-com.da3277dd.svg";